import React from 'react';

interface MainDashboardProps {
  onBoardsClick: () => void;
  onTaskListClick: () => void;
  onSchoolContactSearchClick: () => void;
}

const MainDashboard: React.FC<MainDashboardProps> = ({
  onBoardsClick,
  onTaskListClick,
  onSchoolContactSearchClick,
}) => (
  <div
    className="flex flex-col items-center mt-10 w-full"
    style={{ backgroundColor: '#fdfdfd', minHeight: '100vh' }}
  >
    <h1 className="text-2xl font-bold mb-2 text-orange-500">Main Dashboard</h1>
    <p>Welcome to our dashboard.</p>
    <button className="text-blue-600 underline" onClick={onBoardsClick}>
      View Boards
    </button>
    <button className="text-blue-600 underline mt-2" onClick={onTaskListClick}>
      View Task List
    </button>
    <button
      className="text-blue-600 underline mt-2"
      onClick={onSchoolContactSearchClick}
    >
      School Contact Search
    </button>
  </div>
);

export default MainDashboard;
